module.exports = __webpack_public_path__ + "static/media/def_house_img.7daa589f.jpg";